module.exports = __webpack_public_path__ + "static/media/Conventional_Home_Loans.c3b04fc5.png";